import IContact from '../../interfaces/customerOpinions/customerOpinions';

export const getCustomerOpinionsDataModel = (data: IContact) => {
	const model = {
		Name: data.name,
		Email: data.email,
		Ssn: data.ssn,
		MessageType: data.messageType.value,
		Comments: data.comments,
	};

	return model;
};
